import { Component, OnInit } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { apiService } from 'app/services/api.service';

@Component({
  selector: 'app-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  styleUrls: ['./terms-and-conditions.component.scss']
})
export class TermsAndConditionsComponent implements OnInit {
  termsAndConditionContent: any;

  constructor(private api: apiService, private metaService: Meta) { }

  ngOnInit() {
    // Assuming 'languageCode' is stored in localStorage
    const languageCode = localStorage.getItem('languageCode') || 'en'; // Use 'en' as default if not found

    this.api.getPageCode().subscribe(pageCode => {
      const aboutUsPageCode = 'Terms_and_Conditions';

      this.api.getPageContent(aboutUsPageCode, languageCode).subscribe(response => {
        this.termsAndConditionContent = response.data; // Assign the content to the variable

        this.metaService.updateTag({
          name: 'title', content: this.termsAndConditionContent.meta_title
        });

        this.metaService.updateTag({
          name: 'keywords', content: this.termsAndConditionContent.keywords
        });

        this.metaService.updateTag({
          name: 'description', content: this.termsAndConditionContent.meta_description
        });
      });
    });
  }

}
